import React from 'react'
import StatisticsUncompleteBasketPage from './StatisticsUncompleteBasketPage'
import '../styles/index.scss'

const StatisticsUncompleteBasketContainer = () => {
    return (
        <div className='StatisticsUncompleteBasketContainer'>
            <StatisticsUncompleteBasketPage />
        </div>
    )
}

export default StatisticsUncompleteBasketContainer